import { httpPost } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';

/**
 * Requests OTP code for user
 *
 * @method requestOtp
 * @memberof OTP
 * @param  {string} phone? - Optional phone number if setting up or changing OTP number
 * @returns {Promise<boolean>} - Returns true if OTP request successfully sent
 */

export const requestOtp = async (phone?: string): Promise<boolean> => {
  const apiRoute = `${Constants.BACKEND_URL}/auth/otp`;
  const url = phone ? `${apiRoute}/request/${phone}` : `${apiRoute}/request`;

  return httpPost(url, { phone })
    .then((response) => {
      if (response?.status === 200 && response?.data.success) {
        return true;
      }

      return false;
    })
    .catch((error) => {
      throw Error(`Error requesting token: ${error}`);
    });
};
